/**
 * Iterate through the provided array and apply an ID property to each index.
 *
 * @param   { Array }  arr  an array of objects is required.
 * @return  { Array }       returns the same array of objects, where each object has a prop of `id: 0`, etc.
 */
export const addIdToData = function (arr) {
  for (var i = 0; i < arr.length; i++) {
    arr[i]['id'] = i + 1;
  }
  return arr;
}